/* eslint-disable consistent-return */
import MDAlert from "components/Basics/MDAlert";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { selectNotifications } from "redux-react/reducers/notificationsReducer";
import { selectNotificationsList, selectCurrentProfile } from "redux-react/reducers/profileReducer";
import { selectSnackBar, hide, removeMessage } from "redux-react/reducers/snackBarReducer";
import "./snackbar.css";
/**
 * #######################################################@
 *
 * SnackBar component
 *
 * Used to display a message in a snackbar by the store
 *
 * #######################################################@
 */
import { Alert, Icon, Slide, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const SnackBarMessage = () => {
	const dispatch = useDispatch();
	const profile = useSelector(selectCurrentProfile);
	const snackBar = useSelector(selectSnackBar);
	const notifications = useSelector(selectNotifications);
	const notificationsList = useSelector(selectNotificationsList);

	const handleClose = id => {
		dispatch(removeMessage({ id }));
	};

	const [alertContent, setAlertContent] = useState("");

	const [showAlert, setShowAlert] = useState(false);

	const [oldLength, setOldLength] = useState({});

	const getSeverity = type => {
		if (type === "loading") {
			return "info";
		}

		return type ?? "info";
	};

	useEffect(() => {
		if (!notificationsList.length) {
			setOldLength({
				...oldLength,
				[profile.assistantID]: 0
			});
			return;
		}

		if (notificationsList.length > (oldLength[profile.assistantID] || 0)) {
			setOldLength({
				...oldLength,
				[profile.assistantID]: notificationsList.length
			});
			setAlertContent(notificationsList[notificationsList.length - 1].message);
			setShowAlert(() => {
				return false;
			});
			setShowAlert(() => {
				return true;
			});

			const timer = setTimeout(() => {
				setShowAlert(() => {
					return false;
				});
			}, 5000);

			// return () => clearTimeout(timer);
		}
	}, [notifications, dispatch]);

	// Auto-hide snackbar messages after 5 seconds
	useEffect(() => {
		const timers = [];

		snackBar.messages.forEach(message => {
			if (!message.validation && message.type !== "loading") {
				const timer = setTimeout(() => {
					handleClose(message.id);
				}, 5000);

				timers.push(timer);
			}
		});

		return () => {
			timers.forEach(timer => clearTimeout(timer));
		};
	}, [snackBar.messages]);

	return (
		<>
			{/*
			 * Notifications
			 */}
			<div className="notificationsContainer">
				<Slide in={showAlert} direction="down">
					<div>
						<MDAlert color={getSeverity(notificationsList[notificationsList.length - 1]?.type)}>
							<Icon fontSize="small">notifications</Icon>
							<MDTypography variant="body2" color="white">
								{alertContent ?? "Nouvelle notification !"}
							</MDTypography>
						</MDAlert>
					</div>
				</Slide>
			</div>
			{/*
			 * SnackBar Stack
			 */}
			<div className="snackBarContainer">
				{snackBar.messages.map((message, index) => (
					<Slide
						key={message.id}
						in
						direction="right"
						style={{ transitionDelay: `${index * 50}ms` }}
					>
						<div className="snackBarWrapper">
							<Alert
								icon={message.type === "loading" ? false : null}
								severity={getSeverity(message.type)}
								onClose={() =>
									message.validation || message.type === "loading" ? null : handleClose(message.id)
								}
								style={{
									display: "flex",
									alignItems: "center",
									width: "100%"
								}}
							>
								<MDBox display="flex" alignItems="center">
									{message.type === "loading" && (
										<CircularProgress color="inherit" size={20} style={{ marginRight: 10 }} />
									)}
									{message.message ?? ""}
									{message.validation ? message.validation : null}
								</MDBox>
							</Alert>
						</div>
					</Slide>
				))}
			</div>
		</>
	);
};

export default SnackBarMessage;
